var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSchedule = function SvgSchedule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#schedule_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.286 10.667h1.667M13.453 10.667h1.666M6.786 10.667H5.12M9.286 14.833h1.667M13.453 14.833h1.666M6.786 14.833H5.12M4.704 3.818a34 34 0 0 0-1.23.14 2.01 2.01 0 0 0-1.747 1.727c-.17 1.185-.358 3.07-.358 5.607s.188 4.422.358 5.607c.132.915.83 1.604 1.747 1.727 1.304.174 3.492.374 6.645.374 3.154 0 5.341-.2 6.646-.374a2.01 2.01 0 0 0 1.747-1.727c.17-1.185.357-3.07.357-5.607s-.187-4.422-.357-5.607a2.01 2.01 0 0 0-1.747-1.727q-.615-.08-1.23-.14M12.203 3.614a68 68 0 0 0-4.167 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.208 4.113c.018.866.587 1.539 1.454 1.552q.207.003.415 0c.867-.013 1.436-.686 1.454-1.553q.01-.528 0-1.058c-.018-.866-.588-1.539-1.454-1.552a14 14 0 0 0-.415 0c-.867.013-1.436.686-1.454 1.552q-.01.53 0 1.059M4.708 4.113c.018.866.587 1.539 1.454 1.552q.208.003.415 0c.867-.013 1.436-.686 1.454-1.553q.01-.528 0-1.058c-.018-.866-.587-1.539-1.454-1.552a14 14 0 0 0-.415 0c-.867.013-1.436.686-1.454 1.552a26 26 0 0 0 0 1.059"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "schedule_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.12.25h20v20h-20z"
  })))));
};
export default SvgSchedule;